import { useEffect } from "react";
import { useSnackbar } from "notistack";
import useAuth from "src/hooks/useAuth";
import { runRecoveryOnce } from "src/pages/user/financial/buy-package/metamask/use-recharge-with-metamask";

const RETURN_URL_TTL_MS = 5 * 60 * 1000;

// If MetaMask Mobile reloaded the WebView at the base URL after a recent tx,
// React Router would have bounced the user from / -> /auth/login -> /user/dashboard.
// We saved the recharge page URL just before contract.transfer(); use it to
// navigate back. Returns true if a redirect happened.
const restorePreMetamaskUrlIfStale = () => {
  try {
    const raw = localStorage.getItem("metamaskReturnUrl");
    if (!raw) return false;
    const { url, timestamp } = JSON.parse(raw);
    const fresh = Date.now() - (timestamp || 0) < RETURN_URL_TTL_MS;
    if (!fresh) {
      localStorage.removeItem("metamaskReturnUrl");
      return false;
    }
    const here = window.location.pathname + window.location.search;
    if (url && url !== here) {
      localStorage.removeItem("metamaskReturnUrl");
      window.location.href = url;
      return true;
    }
    // We're already on the right page; clear the marker.
    localStorage.removeItem("metamaskReturnUrl");
    return false;
  } catch {
    return false;
  }
};

const MetamaskRechargeRecovery = () => {
  const { enqueueSnackbar } = useSnackbar();
  const { user } = useAuth();
  const userId = user?.id;

  // URL restoration runs immediately on mount, before auth has resolved.
  // Reading localStorage doesn't need auth and we want to bounce the user
  // off /user/dashboard ASAP so they don't think the recharge failed.
  useEffect(() => {
    restorePreMetamaskUrlIfStale();
  }, []);

  // Recovery requires an authenticated session.
  useEffect(() => {
    if (!userId) return;
    runRecoveryOnce(enqueueSnackbar, userId).catch(() => {});
  }, [userId, enqueueSnackbar]);

  return null;
};

export default MetamaskRechargeRecovery;
